import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ReplaySubject, Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ShClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { ActionItem } from '../action-item/entities/action-item.entity';
import { ShCompactNavigationItemComponent } from '../compact-navigation-item/compact-navigation-item/compact-navigation-item.component';
import { ShCompactNavigationMainActionComponent } from '../compact-navigation-item/compact-navigation-main-action/compact-navigation-main-action.component';
import { ShIconModule } from '../icon/icon.module';
import { NavigationItem, OpenableNavigationItem } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-compact-navigation',
    templateUrl: './compact-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterModule,
        CommonModule,
        ShIconModule,
        ShCompactNavigationItemComponent,
        ShCompactNavigationMainActionComponent,
        ShClickOutsideDirective
    ]
})
export class ShCompactNavigationComponent {
    primaryNavItems$: Subject<OpenableNavigationItem[]> = new ReplaySubject(1);
    secondaryNavItems$: Subject<OpenableNavigationItem[]> = new ReplaySubject(1);

    @Input() mainActionItem!: ActionItem;
    @Input() set primaryNavItems(primaryNavItems: NavigationItem[]) {
        this.primaryNavItems$.next(primaryNavItems);
    }

    @Input() set secondaryNavItems(secondaryNavItems: NavigationItem[]) {
        this.secondaryNavItems$.next(secondaryNavItems);
    }

    @Input() applicationName: string;
    @Input() applicationEnvironment: string;
    @Input() applicationVersion: string;
    @Input() showApplicationInformation: boolean = false;

    selectionChanged(selected: boolean, selectedIndex: number, navItems: NavigationItem[], primary: boolean) {
        if (selected) {
            this.handleSelected(selectedIndex, navItems, primary);
        } else {
            this.handleDeselected(navItems, primary);
        }
    }

    noneSelected(navItems: NavigationItem[], primary: boolean) {
        if (navItems) {
            this.handleDeselected(navItems, primary);
        }
    }

    trackByHash = (index: number, item: any) => {
        return JSON.stringify(item);
    };

    private handleSelected(selectedIndex: number, navItems: NavigationItem[], primary: boolean): void {
        const updatedNavItems = navItems.map((navItem, index) => {
            const newItem: OpenableNavigationItem = {
                ...navItem,
                isOpen: index === selectedIndex
            };
            return newItem;
        });
        this.updateNavItems(primary, updatedNavItems);
    }

    private handleDeselected(navItems: NavigationItem[], primary: boolean): void {
        const updatedNavItems = navItems.map((navItem, index) => {
            const newItem: OpenableNavigationItem = {
                ...navItem,
                isOpen: false
            };
            return newItem;
        });
        this.updateNavItems(primary, updatedNavItems);
    }

    private updateNavItems(primary: boolean, updatedNavItems: OpenableNavigationItem[]) {
        if (primary) {
            this.primaryNavItems$.next(updatedNavItems);
        } else {
            this.secondaryNavItems$.next(updatedNavItems);
        }
    }
}
